import {fuzzy} from 'fast-fuzzy'

export function MakeStringMatcher(searchTerm) {
    return function(text, returnMatchData) {
        let result = fuzzy(searchTerm, text, { useSeparatedUnicode: true, ignoreSymbols: false, returnMatchData });
        if(returnMatchData) {
			return {
				score: result.score,
				match: result.score > 0.9 ? result.match : null
			};
        } else {
			return {
				score: result,
				match: result > 0.9
			};
        }
    }
}
